import React from 'react';

import { Link } from '@mui/material';

interface Props {
  kind: 'email' | 'phone';
  value: string | null;
}

export default function ContactMethodLink({ kind, value }: Props) {
  if (!value) {
    return <>—</>;
  }

  const href = kind === 'email' ? `mailto:${value}` : `tel:${value.replace(/\s/g, '')}`;
  return (
    <Link href={href} underline="hover">
      {value}
    </Link>
  );
}
